<script setup lang="ts">
import { computed } from 'vue'
import { useAudienceStore } from '@/app/stores/audience'
import { translateAudienceText } from '@/core/i18n/audienceText'

const props = withDefaults(defineProps<{ text: string; english?: string; variant?: 'default' | 'inline' | 'topbar' | 'hero'; path?: string; itemId?: string | null }>(), {
  english: '',
  variant: 'default',
  path: undefined,
  itemId: null,
})
const audience = useAudienceStore()
const translatedText = computed(() => props.english.trim() || translateAudienceText(audience.config, props.text, props.path, props.itemId))
const useEnglish = computed(() => audience.locale === 'en' && Boolean(translatedText.value))
const visibleText = computed(() => useEnglish.value ? translatedText.value : props.text)
</script>

<template>
  <span class="bi-text single-lang" :class="[`is-${useEnglish ? 'en' : 'zh'}`, `vf-bi-text--${variant}`]">
    <span class="bi-cn">{{ visibleText }}</span>
  </span>
</template>
